import { useLocation } from 'react-router-dom';

export const useModuleFromRoute = () => {
  const location = useLocation();
  const match = location.pathname.match(/^\/([^/]+)\//);
  return match ? match[1] : null;
};
